import React, { useEffect, useRef } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { useSmartTranslation } from '../../hooks/useSmartTranslation'
import AlertUI from '../../AlertUI'

// Room between the notice and what follows it (the toolbar, the filters, the dialog body).
const NOTICE_SPACING = { sx: { mb: 2 } }

// Historia 226 (CU6, CU7): the truncation question and the print notice of `useLabelPrintFlow`. A success hides by
// itself; an error stays until the user closes it or retries (S137). E24: the notice is MIC's AlertUI, drawn where this
// component is placed (the top of the screen or dialog), with the ✕ and, for printer failures, Retry next to it.
const LabelPrintFeedback = ({ notice, question, answer, closeNotice }) => {
  const { t_ } = useSmartTranslation()
  const [AlertElement, showAlert, dismissAlert] = AlertUI(NOTICE_SPACING)
  // Shown only when the notice changes: `showAlert` and `t_` change identity on every render, and keying on them would
  // bring back a success that already hid by itself.
  const latest = useRef({ showAlert, dismissAlert, closeNotice, t_ })
  latest.current = { showAlert, dismissAlert, closeNotice, t_ }

  useEffect(() => {
    const { showAlert: show, dismissAlert: dismiss, closeNotice: close, t_: translate } = latest.current
    if (!notice.open) {
      dismiss()
      return
    }
    const [title, ...rest] = notice.lines
    show({
      severity: notice.severity,
      title,
      message: rest.length > 0 ? <>{rest.map((line) => <Box key={line}>{line}</Box>)}</> : ' ',
      duration: notice.severity === 'success' ? 6000 : null,
      action: notice.retry ? { label: translate('Retry printing'), onClick: () => { close(); notice.retry() } } : undefined,
      onClose: close
    })
  }, [notice])

  return (
    <>
      {AlertElement}
      <Dialog open={question.open} onClose={() => answer(false)}>
        <DialogContent>{question.text}</DialogContent>
        <DialogActions>
          <Button onClick={() => answer(false)}>{t_('Cancel')}</Button>
          <Button variant='contained' onClick={() => answer(true)}>{t_('Print anyway')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default LabelPrintFeedback
